import { api } from './apiClient'
import { getDemoFlag } from '../hooks/useDemoMode'
import { isFeatureEnabled } from './featureFlags'

const STATUS_TTL_MS = 60_000

let cachedStatus = null
let cachedAt = 0
let inflightFetch = null

const fetchStatus = async () => {
  if (Date.now() - cachedAt < STATUS_TTL_MS && cachedStatus) return cachedStatus
  if (inflightFetch) return inflightFetch
  inflightFetch = (async () => {
    try {
      const data = await api.getQuickBooksStatus()
      cachedStatus = data
      cachedAt = Date.now()
      return data
    } catch (err) {
      console.warn('[QBSync] status fetch failed', err)
      cachedStatus = { connected: false }
      cachedAt = Date.now()
      return cachedStatus
    } finally {
      inflightFetch = null
    }
  })()
  return inflightFetch
}

export const invalidateQuickBooksStatusCache = () => {
  cachedStatus = null
  cachedAt = 0
}

const isEntityEnabled = (status, entityType) => {
  if (!status?.connected) return false
  if (status.syncSettings?.autoSyncOnWrite === false) return false
  const settings = status.syncSettings || {}
  if (entityType === 'client') return !!settings.syncCustomers
  if (entityType === 'invoice') return !!settings.syncInvoices
  if (entityType === 'expense') return !!settings.syncExpenses
  return false
}

/**
 * Fire-and-forget push of a single CRM entity to QuickBooks.
 * Never throws — failures are logged and surfaced via the Integrations page sync log.
 *
 * @param {'client'|'invoice'|'expense'} entityType
 * @param {string} entityId
 */
export const triggerQuickBooksSync = (entityType, entityId) => {
  if (!entityId) return
  if (getDemoFlag()) return
  if (!isFeatureEnabled('INTEGRATIONS_ENABLED')) return

  // Detach from the calling code path so the UI never blocks on QB I/O.
  queueMicrotask(async () => {
    try {
      const status = await fetchStatus()
      if (!isEntityEnabled(status, entityType)) return
      await api.syncQuickBooksEntity(entityType, entityId)
    } catch (err) {
      console.warn(`[QBSync] background ${entityType} sync failed`, err)
    }
  })
}
